import { AutogenModelTemplateRateConfirmation, AutogenRowTemplateRateConfirmation } from "./autogen/AutogenModelTemplateRateConfirmation";

export class ModelTemplateRateConfirmation extends AutogenModelTemplateRateConfirmation<RowTemplateRateConfirmation> {
    constructor() {
        super(RowTemplateRateConfirmation);
    }
}

export class RowTemplateRateConfirmation extends AutogenRowTemplateRateConfirmation {
}